var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        {
          attrs: {
            align: "center"
          }
        },
        [
          _c(
            "v-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.pageLoaded,
                  expression: "!pageLoaded"
                }
              ]
            },
            [
              _c(
                "gg-card",
                [
                  _c("v-card-text", [
                    _c(
                      "div",
                      {
                        staticClass: "flex justify-center pt-5 pb-5"
                      },
                      [
                        _c("v-progress-circular", {
                          attrs: {
                            indeterminate: "",
                            size: "64",
                            color: "primary"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pageLoaded,
                  expression: "pageLoaded"
                }
              ]
            },
            [
              _vm.isServiceIdAvailable
                ? _c(
                    "gg-card",
                    [
                      _c(
                        "v-stepper",
                        {
                          attrs: {
                            vertical: ""
                          },
                          model: {
                            value: _vm.step,
                            callback: function callback($$v) {
                              _vm.step = $$v
                            },
                            expression: "step"
                          }
                        },
                        [
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.step > 1,
                                step: "1"
                              }
                            },
                            [_vm._v(" Reason for Cancellation ")]
                          ),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "1"
                              }
                            },
                            [
                              _c("cancel-reasons", {
                                on: {
                                  "step-back": _vm.stepBack,
                                  "offer-accepted": _vm.offerAccepted,
                                  "offer-declined": function offerDeclined(
                                    $event
                                  ) {
                                    return _vm.offerDeclined(2)
                                  },
                                  "no-offer": function noOffer($event) {
                                    return _vm.noOffer(2)
                                  },
                                  "set-comment": _vm.setComment,
                                  "set-additional-question":
                                    _vm.setAdditionalQuestion,
                                  cancel: _vm.moveToService,
                                  "go-to-last-step": function goToLastStep(
                                    $event
                                  ) {
                                    return _vm.moveToStep(3)
                                  },
                                  "page-loaded": function pageLoaded($event) {
                                    _vm.pageLoaded = true
                                  },
                                  "cr-opened": _vm.crOpened
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.step > 2,
                                step: "2"
                              }
                            },
                            [_vm._v(" Additional Information ")]
                          ),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "2"
                              }
                            },
                            [
                              _c("additional-information", {
                                ref: "additionalInfo",
                                attrs: {
                                  "additional-question": _vm.additionalQuestion
                                },
                                on: {
                                  "next-step": _vm.nextStep,
                                  "set-comment": _vm.setComment,
                                  "offer-accepted": _vm.offerAccepted,
                                  "offer-declined": function offerDeclined(
                                    $event
                                  ) {
                                    return _vm.offerDeclined(3)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.step > 3,
                                step: "3"
                              }
                            },
                            [_vm._v(" Review ")]
                          ),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "3"
                              }
                            },
                            [
                              _c("cancel-review", {
                                attrs: {
                                  comment: _vm.comment
                                },
                                on: {
                                  "step-back": _vm.stepBack,
                                  "cr-opened": _vm.crOpened,
                                  cancel: _vm.moveToService,
                                  close: _vm.moveToService
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.step >= 4,
                                step: "4"
                              }
                            },
                            [_vm._v(" Confirmation ")]
                          ),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "4"
                              }
                            },
                            [
                              _c("cancel-confirmation", {
                                attrs: {
                                  template: _vm.template,
                                  cr_escalate: _vm.cr_escalate,
                                  cr_open: _vm.cr_open
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "gg-card",
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "d-block text-left"
                        },
                        [_c("h3", [_vm._v("Cancel Service")])]
                      ),
                      _c("v-card-text", [
                        _vm._v(
                          " You may cancel your service by clicking Manage for the service you want to cancel, then clicking the Stop Renewal option. "
                        )
                      ])
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }